<template>
    <div>
        <v-server-table ref="reportList" :url="`/reports`" :columns="columns" :options="options">
            <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

            </div>

            <div slot="afterFilter" class="ml-2">

            </div>

            <template slot="is_starred" slot-scope="props">
                <a href="javascript:void(0)" @click="starReport(props.row, props.row.is_starred ? 0 : 1)"><i :class="getIconClass(props.row)" @mouseover="$set(is_hovered, props.row.id, true)" @mouseleave="$set(is_hovered, props.row.id, false)" /></a>
            </template>

            <template slot="id" slot-scope="props">
                <router-link :to="savedReportUrl(props.row)" class="btn btn-sm btn-secondary" title="View Saved Report">View</router-link>
            </template>

            <template slot="report_name" slot-scope="props">
                <router-link :to="savedReportUrl(props.row)" title="View Saved Report">{{ props.row.report_name }}</router-link>
            </template>

            <template slot="created_at" slot-scope="props">
                {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>
        </v-server-table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                is_hovered: {},
                userTimezone: this.$root.timezone,
                columns: ['is_starred', 'id', 'report_name', 'report_class', 'created_at'],
                options: {
                    headings: {
                        is_starred: 'Starred',
                        id: 'Actions',
                        report_name: 'Report Name',
                        report_class: 'Report Type',
                        created_at: 'Created At',
                    },
                    texts:{
                        filterPlaceholder:"Search Reports",
                    },
                    orderBy: {
                        ascending: false,
                        column: 'reports.report_name',
                    },
                    responseAdapter: (response) => {
                        //Send it
                        return response.data;
                    },
                    uniqueKey: 'id',
                },
            }
        },

        methods: {
            getIconClass(report) {
                if (report.is_starred && this.is_hovered[report.id] || !report.is_starred && !this.is_hovered[report.id])
                {
                    return 'far fa-star text-dark';
                }
                else
                {
                    return 'fas fa-star text-warning';
                }
            },

            savedReportUrl(report) {
                let url_map = {
                    'Liaison': '/reports/liaison',
                    'Pareto': '/reports/pareto',
                    'Activity': '/reports/activity',
                    'Invoicing': '/reports/invoicing',
                    'Billing': '/reports/billing',
                    'Payroll': '/reports/payroll',
                }

                let url = url_map[report.report_class];
                url += `?report_id=${report.id}`

                return url;
            },

            starReport(report, is_starred) {
                this.$http
                .post('reports/star', {is_starred: is_starred, report_id: report.id})
                .then(response => {
                    let user = this.$store.state.user;
                    user.reports = response.data;
                    this.$store.commit('login', user);

                    //Alert the user
                    this.$toastr.s('Report Star Updated');

                    //Refresh the data
                    this.$refs.reportList.refresh();
                });
            },
        },

        mounted() {

        }
    }
</script>
